export function validMonth(field) {
    const month = /^[0-9]{2}\/?[0-9]{4}$/;

    if (!month.test(field.value)) {
        return false;
    }

    if (
        parseInt(field.value.substr(0, 2)) < 1 ||
        parseInt(field.value.substr(0, 2)) > 12
    ) {
        return false;
    }

    return true;
}
